import React, { Component } from 'react'
import { Box,TextField,InputAdornment } from '@mui/material'
import { Search } from '@mui/icons-material';
const SearchComponent=({placeholder,handleChange})=>{
    return(
        <Box sx={{width:'100%',justifyContent:'center',alignItems:'center',display:'flex'}}>
        <TextField
          placeholder={placeholder}
          sx={{width:'100%'}}
          onChange={(e)=>handleChange(e.target.value)}
          
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search onChange={(e)=>console.log("serach text",e)}/>
              </InputAdornment>
            ),
          }}
          variant="outlined"
          size="small"
          // onChange={onSearchChange}
        />
        </Box>
    )
}

export default SearchComponent